module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMAAiYnQ0ReYHFysLG0tbbg4fEjLpYAAACHSURBVEjH7dbLCsMgEEDR+NbGRO///2y2KWVImC5K6NylcDaD4iyLZT0yF/uWnBL7ATMocQYoSlwBqhI3gGbY8POxC6W2UyvAej6p2UvvO00uG1HAOzfqAu538CbgOK7tTNLAfP4c2OttYCU4u2GG/xx/9cUWgKzEYcLw2oUm7T1qFxrL+nEHEEQWqgqg3FUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whitePlus.png
// module id = PilA
// module chunks = 1